/* eslint-disable @typescript-eslint/naming-convention */
import type { TextElement } from '@studiobuki/web-core/lib/book-common';
import {
  APJapanesefont_000000_16,
  APJapanesefont_000000_20,
  APJapanesefont_000000_24,
  KaiseiOpti_000000_30,
  KozGoProBold_0b4561_30,
  KozGoProBold_0b4561_31,
  Wahupop_000000_24,
} from './_styles';

const SEGMENT_0_text_value_1 = 'ゆめの{{heroName}}{{kidstitle}}せん';

export const SEGMENT_0_text_1: TextElement = {
  align: 'center',
  style: KozGoProBold_0b4561_31,
  text: SEGMENT_0_text_value_1,
  textPath: 'M 0 0 S 421 -280 842 0',

  x: 0,
  y: 230,
};
const SEGMENT_0_text_value_2 = '{{genderIndex}}のでんしゃ';

export const SEGMENT_0_text_2: TextElement = {
  align: 'center',
  style: KozGoProBold_0b4561_30,
  text: SEGMENT_0_text_value_2,
  textPath: 'M 0 0 S 421 -280 842 0',

  x: 0,
  y: 175,
};

const SEGMENT_1_text_value_1 =
  'でんしゃは　いろんなばしょに　つれていってくれるね\n' +
  'じんせいも　でんしゃみたいだよ。\n' +
  'ときには　とっきゅうみたいに　はやくすすんだり\n' +
  'ときには　かくえきていしゃみたいに\n' +
  'ゆっくりけしきを　たのしんだり。\n' +
  'どんなみちを　えらんでも\n' +
  '{{heroName}}{{kidstitle}}の　だいすきなことを　たいせつにしてね。';

export const SEGMENT_1_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_16,
  text: SEGMENT_1_text_value_1,
  x: 388,
  y: 164,
  width: 400,
  rotation: 3,
};

const SEGMENT_2_text_value_1 = 'いまの　{{heroName}}{{kidstitle}}には、';

export const SEGMENT_2_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_16,
  text: SEGMENT_2_text_value_1,
  x: 20,
  y: 355,
  width: 300,
};

const SEGMENT_4_text_value_1 = '{{heroName}}{{kidstitle}}のでんしゃが';

export const SEGMENT_4_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_4_text_value_1,
  x: 62,
  y: 208,
  width: 230,
  rotation: -30,
};

const SEGMENT_5_text_value_1 = 'このでんしゃはね、{{heroName}}{{kidstitle}}の';

export const SEGMENT_5_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_24,
  text: SEGMENT_5_text_value_1,
  x: 184,
  y: 64,
  width: 400,
};

const SEGMENT_5_text_value_2 = 'だいすきな　{{1st train station}}に';

export const SEGMENT_5_text_2: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_24,
  text: SEGMENT_5_text_value_2,
  x: 360,
  y: 440,
  width: 360,
};

const SEGMENT_11_text_value_1 = 'と、{{heroName}}{{kidstitle}}。';

export const SEGMENT_11_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_16,
  text: SEGMENT_11_text_value_1,
  x: 132,
  y: 55,
  width: 200,
};

const SEGMENT_15_text_value_1 =
  '{{heroName}}{{kidstitle}}は　こえを　かけました。';

export const SEGMENT_15_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_16,
  text: SEGMENT_15_text_value_1,
  x: 453,
  y: 498,
  width: 300,
};

const SEGMENT_17_text_value_1 = '「ありがとう！　{{heroName}}{{kidstitle}}！」';

export const SEGMENT_17_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_16,
  text: SEGMENT_17_text_value_1,
  x: 485,
  y: 150,
  width: 300,
};

const SEGMENT_21_text_value_1 =
  'あるから、いってみよう。」と、{{heroName}}{{kidstitle}}。';

export const SEGMENT_21_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_16,
  text: SEGMENT_21_text_value_1,
  x: 425,
  y: 550,
  width: 340,
};

const SEGMENT_23_text_value_1 = 'と、{{heroName}}{{kidstitle}}。';

export const SEGMENT_23_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_16,
  text: SEGMENT_23_text_value_1,
  x: 590,
  y: 120,
  width: 200,
};

const SEGMENT_24_text_value_1 = '「{{heroName}}{{kidstitle}}、たいへんだ！';

export const SEGMENT_24_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_16,
  text: SEGMENT_24_text_value_1,
  x: 301,
  y: 63,
  width: 400,
};

const SEGMENT_25_text_value_1 = '{{heroName}}{{kidstitle}}、たったひとりで、';

export const SEGMENT_25_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_16,
  text: SEGMENT_25_text_value_1,
  x: 428,
  y: 508,
  width: 300,
};

const SEGMENT_27_text_value_1 =
  '「りょうかいしました、{{heroName}}{{kidstitle}}。すぐに　ぎじゅつしゃを　はけんします！';

export const SEGMENT_27_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_16,
  text: SEGMENT_27_text_value_1,
  x: 116,
  y: 72,
  width: 600,
};
export const SEGMENT_30_text_value_1 =
  'こうして[ゆめのでんしゃ、{{heroName}}ごう]は';

export const SEGMENT_30_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_16,
  text: SEGMENT_30_text_value_1,
  x: 183,
  y: 439,
  width: 600,
};

const SEGMENT_32_text_value_1 =
  '「あら、{{heroName}}{{kidstitle}}。おもちゃで　あそんでたの？」\n「うん！　そうなんだ！　すきなものをつなげて　でんしゃにしたんだ」\n「わぁ、ステキ！　{{heroName}}{{kidstitle}}は　ほんとうに';

export const SEGMENT_32_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_16,
  text: SEGMENT_32_text_value_1,
  x: 92,
  y: 159,
  width: 490,
};

const SEGMENT_32_text_value_2 =
  '{{1st like}}と {{2nd like}}と {{3rd like}}が だいすきだね。';

export const SEGMENT_32_text_2: TextElement = {
  align: 'center',
  style: Wahupop_000000_24,
  text: SEGMENT_32_text_value_2,
  x: 47,
  y: 227,
  width: 600,
};

const SEGMENT_32_text_value_3 =
  'だいすきなものが　いっぱいある　{{heroName}}{{kidstitle}}は　すてきだよ」';

export const SEGMENT_32_text_3: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_16,
  text: SEGMENT_32_text_value_3,
  x: 92,
  y: 258,
  width: 490,
};

export const SEGMENT_34_text_value_1 =
  '{{heroName}}{{kidstitle}}のゆめのでんしゃず';

export const SEGMENT_34_text_1: TextElement = {
  align: 'center',
  style: KaiseiOpti_000000_30,
  text: SEGMENT_34_text_value_1,
  x: 128,
  y: 61,
  width: 550,
};

const SEGMENT_99030_text_value_1 =
  'ここには　{{heroName}}{{kidstitle}}のだいすきな';

export const SEGMENT_99030_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99030_text_value_1,
  x: 156,
  y: 57,
  width: 480,
};

export const SEGMENT_99031_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99030_text_value_1,
  x: 100,
  y: 475,
  width: 480,
};

const SEGMENT_99032_text_value_1 =
  'ここには　{{heroName}}{{kidstitle}}のだいすきな　たべもので　あふれてる！';

export const SEGMENT_99032_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99032_text_value_1,
  x: 86,
  y: 493,
  width: 460,
};

const SEGMENT_99034_text_value_1 =
  '{{heroName}}{{kidstitle}}にとって　すごしやすい　ばしょは　どこかな？';

export const SEGMENT_99034_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99034_text_value_1,
  x: 2,
  y: 109,
  width: 600,
};

const SEGMENT_99035_text_value_1 =
  'ここでは、みんなクリエイター！　{{heroName}}{{kidstitle}}も　そうだよね？';

export const SEGMENT_99035_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99035_text_value_1,
  x: -18,
  y: 515,
  width: 600,
};

const SEGMENT_99037_text_value_1 =
  '{{heroName}}{{kidstitle}}、よかったら、てつだってくれる？';

export const SEGMENT_99037_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99037_text_value_1,
  x: 217,
  y: 68,
  width: 500,
};

const SEGMENT_99038_text_value_1 =
  '{{heroName}}{{kidstitle}}、いっしょに　さがしてくれるかな？';

export const SEGMENT_99038_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99038_text_value_1,
  x: 126,
  y: 158,
  width: 500,
};

const SEGMENT_99042_text_value_1 =
  'ほんとうに　{{heroName}}{{kidstitle}}は　むしのもりのことを　しってるね。';

export const SEGMENT_99042_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99042_text_value_1,
  x: 144,
  y: 448,
  width: 490,
};

const SEGMENT_99042_text_value_2 =
  '{{heroName}}{{kidstitle}}　だいすきに　なってくれて　ありがとう。';

export const SEGMENT_99042_text_2: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99042_text_value_2,
  x: 40,
  y: 45,
  width: 460,
};

const SEGMENT_99043_text_value_1 =
  '{{heroName}}{{kidstitle}}、さがしものを　てつだってくれてありがとう！';

export const SEGMENT_99043_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99043_text_value_1,
  x: 44,
  y: 40,
  width: 460,
};

const SEGMENT_99043_text_value_2 = '{{heroName}}{{kidstitle}}　きょうりゅうや';

export const SEGMENT_99043_text_2: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99043_text_value_2,
  x: 450,
  y: 515,
  width: 340,
};

const SEGMENT_99044_text_value_1 =
  '{{heroName}}{{kidstitle}}、みんなを　みつけてありがとう！';

export const SEGMENT_99044_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99044_text_value_1,
  x: 81,
  y: 40,
  width: 410,
};

const SEGMENT_99045_text_value_1 = '{{heroName}}{{kidstitle}}、';

export const SEGMENT_99045_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99045_text_value_1,
  x: 44,
  y: 66,
  width: 200,
};

const SEGMENT_99045_text_value_2 =
  '{{heroName}}{{kidstitle}}　わたしたちを　すきになってくれて　ありがとう。';

export const SEGMENT_99045_text_2: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99045_text_value_2,
  x: 379,
  y: 517,
  width: 280,
};

const SEGMENT_99046_text_value_1 = '{{heroName}}{{kidstitle}}、';

export const SEGMENT_99046_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99046_text_value_1,
  x: 17,
  y: 69,
  width: 280,
};

const SEGMENT_99046_text_value_2 =
  '{{heroName}}{{kidstitle}}、　ぼくたちのことを　すきでいてくれて、ありがとう。';

export const SEGMENT_99046_text_2: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99046_text_value_2,
  x: 193,
  y: 485,
  width: 550,
};

const SEGMENT_99047_text_value_1 =
  '{{heroName}}{{kidstitle}}、みつけてくれて　ありがとう！';

export const SEGMENT_99047_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99047_text_value_1,
  x: 35,
  y: 39,
  width: 500,
};
const SEGMENT_99047_text_value_2 =
  '{{heroName}}{{kidstitle}}、つくりたいものがあるって　すてきだね。';

export const SEGMENT_99047_text_2: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_20,
  text: SEGMENT_99047_text_value_2,
  x: 62,
  y: 488,
  width: 500,
};
